// Тема кабинета. Выбор хранится в localStorage('theme'): 'light' | 'dark' | 'system'.
// Атрибут data-theme на <html> ставится ещё до React — скриптом в public/index.html,
// здесь та же логика для переключения на лету. Цвета — в assets/css/theme.css.

const STORAGE_KEY = 'theme'
const listeners = new Set()
const media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null

export function getThemePreference() {
	try {
		const value = localStorage.getItem(STORAGE_KEY)
		if (value === 'light' || value === 'dark' || value === 'system') return value
	} catch (e) { }
	return 'light'
}

export function resolveTheme(preference = getThemePreference()) {
	if (preference === 'system') return media && media.matches ? 'dark' : 'light'
	return preference
}

export function getActiveTheme() {
	return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'
}

export function applyTheme(preference = getThemePreference()) {
	const theme = resolveTheme(preference)
	document.documentElement.setAttribute('data-theme', theme)
	listeners.forEach(fn => fn(theme))
}

export function setThemePreference(preference) {
	try {
		localStorage.setItem(STORAGE_KEY, preference)
	} catch (e) { }
	applyTheme(preference)
}

// подписка на смену активной темы (графики и прочее, что красится из JS)
export function onThemeChange(fn) {
	listeners.add(fn)
	return () => listeners.delete(fn)
}

if (media) {
	const onSystemChange = () => {
		if (getThemePreference() === 'system') applyTheme('system')
	}
	if (media.addEventListener) media.addEventListener('change', onSystemChange)
	else if (media.addListener) media.addListener(onSystemChange)
}

// выбор темы в другой вкладке
window.addEventListener('storage', (event) => {
	if (event.key === STORAGE_KEY) applyTheme()
})
